import React from 'react';
import { View, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { BottomSheetModal } from '@/components/residents/marketplace/shared/BottomSheetModal';
import { useResponsive } from '@/hooks/common/useResponsive';
import { CORK_BOARD_COLORS } from './corkBoardStyles';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';

interface AdaptiveMenuProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
  anchor?: 'right' | 'left';
}

export const AdaptiveMenu: React.FC<AdaptiveMenuProps> = ({
  visible,
  onClose,
  children,
  anchor = 'right',
}) => {
  const { layoutMode } = useResponsive();

  if (layoutMode === 'mobile' || layoutMode === 'tablet') {
    return (
      <BottomSheetModal visible={visible} onClose={onClose}>
        {children}
      </BottomSheetModal>
    );
  }

  if (!visible) return null;

  return (
    <View style={styles.wrapper}>
      <TouchableOpacity
        style={styles.overlay}
        activeOpacity={1}
        onPress={onClose}
        accessibilityRole="button"
        accessibilityLabel="Close menu"
      />
      <View style={[styles.popover, anchor === 'left' ? styles.anchorLeft : styles.anchorRight]}>
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    position: 'absolute',
    top: '100%',
    right: 0,
    zIndex: 1000,
  },
  overlay: {
    ...(Platform.OS === 'web' ? { position: 'fixed' as any } : { position: 'absolute' }),
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0,
  },
  popover: {
    position: 'relative',
    marginTop: 4,
    minWidth: 180,
    backgroundColor: PRIMITIVE_COLORS.gray850,
    borderWidth: 1,
    borderColor: CORK_BOARD_COLORS.cardBorder,
    borderRadius: 12,
    paddingVertical: 6,
    paddingHorizontal: 6,
    zIndex: 1,
    ...Platform.select({
      web: {
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
      },
      default: {
        elevation: 8,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.3,
        shadowRadius: 8,
      },
    }),
  },
  anchorRight: {
    right: 0,
  },
  anchorLeft: {
    left: 0,
  },
});
